import store from "../store-root";
import api from "../../service/api";

const moduleName = "inOutRank"; //收支排行榜

store.registerModule(moduleName, {
  namespaced: true,
  state: {},
  actions: {
    //获取收支排行榜
    async getInOutRank({ commit }, payload) {
      let result = await api.get(
        `/api/PaymentListReport?payment=${payload.payment}&Batch=${
          payload.batch
        }&StartDate=${payload.startDate}&EndDate=${payload.endDate}`
      );
      return result.data;
    }
  },
  mutations: {},
  getters: {}
});

export default moduleName;
